import React, { Component } from 'react';
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import LinearProgress from '@material-ui/core/LinearProgress';
import DateBox from './DateBox';
import GradeIcon from './GradeIcon';
import { TRANSLATE_TAG, ROLE } from '../../../const';
import * as taskService from '../../../services/domain/taskService';
import { DropdownList } from '../../common/dropdownList/dropDownList';
import { UserDataProgress } from '../../common/userDataProgress/userDataProgress';
import {
  getDueDateDiffInDays,
  getDueDateDiffInNaturalDays,
  getDueDateDiffInMinutes,
  getDueDateDiffInHours,
  getDueDateDiffInNaturalHours,
  isFuture
} from '../../../utils/dateUtlis';
import { DropdownOptions, Paragraph } from '@netexknowledge/smart-components';
import * as bookApi from '../../../services/api/bookApi';
import * as bookService from '../../../services/domain/bookService';

const styles = {
  root: {
    width: '100%',
    marginTop: 'auto'
  },
  primaryColor: {
    backgroundColor: '#eaf2f5'
  }
};
export class AssignmentCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bookInfo: null
    };
  }

  progress = (totalItemsCompleted, totalItems) => {
    return totalItems ? (totalItemsCompleted / totalItems) * 100 : 0;
  };

  // TODO: Should be refactored in Tasks Phase III
  getDateInfoColor = (dueDate, onTime) => {
    let resultColor = '#ccc';
    if (onTime) {
      if (getDueDateDiffInDays(dueDate) >= 1) {
        resultColor = '#00ace4';
      } else {
        resultColor = '#f05060';
      }
    }
    return resultColor;
  };

  // TODO: Should be refactored in Tasks Phase III
  renderCalendar = (dueDate, onTime) => {
    return (
      <div className="date-info">
        <DateBox color={this.getDateInfoColor(dueDate, onTime)} date={dueDate} />
        {onTime ? (
          <div className="date-info-days-left">
            {getDueDateDiffInDays(dueDate) >= 1 ? (
              <div style={{ color: '#00ace4' }}>
                {I18n.t('tasks.daysLeft').replace(`${TRANSLATE_TAG.DAYS}`, getDueDateDiffInNaturalDays(dueDate))}
              </div>
            ) : getDueDateDiffInHours(dueDate) >= 1 ? (
              <div style={{ color: '#f05060' }}>
                {I18n.t('tasks.hoursLeft').replace(`${TRANSLATE_TAG.HOURS}`, getDueDateDiffInNaturalHours(dueDate))}
              </div>
            ) : (
              <div style={{ color: '#f05060' }}>
                {I18n.t('tasks.minutesLeft').replace(`${TRANSLATE_TAG.MINUTES}`, getDueDateDiffInMinutes(dueDate))}
              </div>
            )}
          </div>
        ) : (
          undefined
        )}
      </div>
    );
  };

  async componentDidMount() {
    const { task } = this.props;
    // If it has "bookActivityId" it means that it is a task associated with content
    if (task.bookActivityId && task.bookId) {
      try {
        // silentNotFound: el libro puede haberse borrado; la tarjeta se pinta sin él
        const bookRes = await bookApi.getBook(task.parentSection, task.bookId, undefined, { silentNotFound: true });
        if (bookRes && bookRes.data) {
          this.setState({ bookInfo: bookService.transformCmi5ToBook(bookRes.data, task.bookId) });
        }
      } catch (err) {
        this.setState({ bookInfo: null });
      }
    }
  }

  renderElements() {
    const { emojis, task } = this.props;
    const userComponents = [];
    task.users.map(user =>
      userComponents.push(<UserDataProgress key={user._id} user={user} task={task} emojis={emojis} />)
    );
    return userComponents;
  }

  renderClassroomName = (
    classroomName,
    classroomColorClass,
    groupName,
    groupColorClass,
    isInstructorView,
    showClassroom
  ) => {
    if (classroomName || groupName) {
      let contentinfo = '';
      let groupInfo = '';
      if (showClassroom && classroomName) {
        contentinfo = <span className={`content-info ${classroomColorClass}`}>{classroomName}</span>;
      }
      if (groupName && isInstructorView) {
        groupInfo = <span className={`group-info ${groupColorClass}`}>{groupName}</span>;
      }

      return (
        <div className="assignment-context">
          {contentinfo}
          {groupInfo}
        </div>
      );
    }
    return <div />;
  };

  getInstructorOptions = (
    onClickEditTask,
    onClickExportPdfTask,
    onClickDeleteTask,
    onClickCloseTask,
    onClickExportCSVTask,
    onClickReassign,
    date
  ) => {
    const { task } = this.props;
    const isTaskGroup = task.studentAttempts[Object.keys(task.studentAttempts)[0]]?.taskGroup !== '';
    const optionItems = [];

    if (isFuture(date)) {
      optionItems.push({
        key: 1,
        text: I18n.t('common.option.edit'),
        onClick: onClickEditTask,
        icon: 'custom-icons-edit-pencil',
        disabled: false
      });
      if (!isTaskGroup) {
        optionItems.push({
          key: 2,
          text: I18n.t('common.option.reassign'),
          onClick: onClickReassign,
          icon: 'custom-icons-assign',
          disabled: false
        });
      }
      optionItems.push({
        key: 3,
        text: I18n.t('common.option.close'),
        onClick: onClickCloseTask,
        icon: 'custom-icons-finish-flag',
        disabled: false
      });
    }

    optionItems.push({
      key: 6,
      text: I18n.t('common.option.csv'),
      onClick: onClickExportCSVTask,
      icon: 'custom-icons-export-file',
      disabled: false
    });

    optionItems.push({
      key: 5,
      text: I18n.t('common.option.pdf'),
      onClick: onClickExportPdfTask,
      icon: 'custom-icons-pdf',
      disabled: false
    });

    optionItems.push({
      key: 4,
      text: I18n.t('common.option.delete'),
      onClick: onClickDeleteTask,
      icon: 'custom-icons-waste-can',
      disabled: false
    });

    const handleChildElementClick = e => {
      e.stopPropagation();
    };

    let dropDown = <DropdownOptions id={'assignment-options'} color="gray" dropdownSide="left" options={optionItems} />;
    return (
      <div className="assignment-options" onClick={e => handleChildElementClick(e)}>
        {dropDown}
      </div>
    );
  };

  renderAssignmentTitle = (
    title,
    isTeacher,
    onClickEditTask,
    onClickExportPdfTask,
    onClickDeleteTask,
    onClickCloseTask,
    onClickExportCSVTask,
    onClickReassign,
    date,
    bookInfo
  ) => {
    let bookName = null;
    if (bookInfo && bookInfo.name) {
      const name = Object.values(bookInfo.name)[0];
      bookName = (
        <Paragraph className="text-grey-500 text-xs gutterBottom" dataText={name}>
          {name}
        </Paragraph>
      );
    }
    return (
      <div className="assignment-wrapper-title">
        <div className="assignment-title">
          {bookName}
          <Paragraph className="p-w-100 text-grey-700 text--1line tooltip bottom" dataText={title}>
            {title}
          </Paragraph>
        </div>
        {isTeacher &&
          this.getInstructorOptions(
            onClickEditTask,
            onClickExportPdfTask,
            onClickDeleteTask,
            onClickCloseTask,
            onClickExportCSVTask,
            onClickReassign,
            date
          )}
      </div>
    );
  };

  renderAssignmentResults = (task, isInstructorView, totalItemsCompleted, totalItems, classes, pendingGrades) => {
    let text = '';
    let icon = '';
    let barProgress = undefined;

    if (task.errorGettingResults) {
      text = I18n.t('tasks.resultsErrors');
      icon = <i className="custom-icons-danger-sign" />;
    } else {
      text = `${totalItemsCompleted}/${totalItems} ${!isInstructorView ? `${I18n.t('tasks.activities')}` : ''}`;
      icon = isInstructorView ? <i className="custom-icons-messenger-user-avatar" /> : undefined;
      barProgress = <LinearProgress variant="determinate" value={this.progress(totalItemsCompleted, totalItems)} />;
    }

    return (
      <div className={classes.root}>
        <span className={`students-indicator ${task.errorGettingResults ? 'error' : ''}`}>
          <div className="students-notification-task">
            {isInstructorView && pendingGrades > 0 ? (
              <div>
                <div className="icon-circle-container">
                  <i className="custom-icons-alarm-bell" />
                </div>
                <span className="students-pending-grades">
                  {pendingGrades} {I18n.t('tasks.pendingGrades')}
                </span>
              </div>
            ) : (
              undefined
            )}
          </div>
          <div className="students-indicator-container">
            <div className="students-indicator-text">{text}</div>
            {icon}
          </div>
        </span>
        {barProgress}
      </div>
    );
  };

  showAssignmentProgress = (task, isInstructorView, hideAssignmentProgress) => {
    const taskWithActivities = !_.isEmpty(taskService.getActivitiesWithoutLessons(task.activities));
    const instructorView = isInstructorView && (task.allowFileResponse || !hideAssignmentProgress);
    return taskWithActivities || instructorView;
  };
  render() {
    const {
      loadTasks,
      classes,
      task,
      onTime,
      groupName,
      classroomName,
      onClickExportPdfTask,
      onClickCard,
      onClickOptions,
      grade,
      groupColorClass,
      totalItemsCompleted,
      totalItems,
      classroomColorClass,
      isInstructorView,
      deleteTask,
      showClassroom,
      pendingGrades,
      onClickCloseTask,
      onClickExportCSVTask,
      onClickReassign,
      hideAssignmentProgress,
      taskImageGroup,
      taskImageIndividual,
      role
    } = this.props;

    const shouldShowGradeIcon = grade !== null && grade > -1 && !onTime && !isInstructorView;
    const showAssignmentResults = this.showAssignmentProgress(task, isInstructorView, hideAssignmentProgress);
    const isTeacher = role === ROLE.INSTRUCTOR;
    const isTaskGroup = task.studentAttempts[Object.keys(task.studentAttempts)[0]]?.taskGroup !== '';
    const bookInfo = this.state.bookInfo;

    return (
      <div className="container-assignment-card" id={'task-card-' + task.id}>
        <div className="assignment-card" onClick={onClickCard}>
          {isTaskGroup ? (
            <img alt={task.name} width="129px" src={taskImageGroup} />
          ) : (
            <img alt={task.name} width="129px" src={taskImageIndividual} />
          )}
          <div className="assignment-info">
            {this.renderClassroomName(
              classroomName,
              classroomColorClass,
              groupName,
              groupColorClass,
              isInstructorView,
              showClassroom
            )}
            <div
              className="assignment-text-icon-container"
              style={{ flexDirection: isInstructorView || onTime ? 'row' : 'row-reverse' }}
            >
              {shouldShowGradeIcon ? <GradeIcon grade={grade} /> : undefined}
              <div className="task-text-container" style={shouldShowGradeIcon ? { width: '80%' } : { width: '100%' }}>
                {this.renderAssignmentTitle(
                  task.name,
                  isTeacher,
                  onClickOptions,
                  onClickExportPdfTask,
                  deleteTask,
                  onClickCloseTask,
                  onClickExportCSVTask,
                  onClickReassign,
                  task.dueDate,
                  bookInfo
                )}
              </div>
            </div>
            {showAssignmentResults ? (
              this.renderAssignmentResults(task, isTeacher, totalItemsCompleted, totalItems, classes, pendingGrades)
            ) : (
              <div />
            )}
          </div>
          {this.renderCalendar(task.dueDate, onTime)}
        </div>
        {this.props.role === 'INSTRUCTOR' ? (
          <DropdownList key={loadTasks} styles="container-expand-button-card" elementsList={this.renderElements()} />
        ) : null}
      </div>
    );
  }
}

AssignmentCard.propTypes = {
  role: PropTypes.string,
  taskImageGroup: PropTypes.string,
  taskImageIndividual: PropTypes.string,
  classes: PropTypes.object,
  task: PropTypes.object,
  onTime: PropTypes.bool,
  groupName: PropTypes.string,
  classroomName: PropTypes.string,
  onClickCard: PropTypes.func,
  onClickExportPdfTask: PropTypes.func,
  onClickExportCSVTask: PropTypes.func,
  onClickOptions: PropTypes.func,
  assignmentOnClick: PropTypes.func,
  grade: PropTypes.number,
  totalItemsCompleted: PropTypes.number,
  totalItems: PropTypes.number,
  classroomColorClass: PropTypes.string,
  isInstructorView: PropTypes.bool,
  groupColorClass: PropTypes.string,
  onClickCloseTask: PropTypes.func,
  onClickReassign: PropTypes.func,
  deleteTask: PropTypes.any,
  showClassroom: PropTypes.any,
  pendingGrades: PropTypes.any,
  hideAssignmentProgress: PropTypes.bool,
  loadTasks: PropTypes.bool,
  emojis: PropTypes.object
};

function mapStateToProps(state) {
  return {
    role: state.classrooms.selectedClassroom.classroom.role,
    taskImageGroup: state.theme.images?.placeholders?.task?.taskImageGroup || null,
    taskImageIndividual: state.theme.images?.placeholders?.task?.taskImageIndividual || null,
    hideAssignmentProgress: state.account.configuration.hideAssignmentProgressWhenNoEvaluable,
    loadTasks: state.task.loadTasks,
    emojis: state.theme.images.emojis,
    book: state.book.book
  };
}

export default connect(mapStateToProps)(injectSheet(styles)(AssignmentCard));
